export default __webpack_public_path__ + "static/media/PlusIcon.58d3e017.svg";